import { create } from 'zustand';
import { checkAuthStatus, logout } from '../api';
import {authURL, baseURL} from "../lib/apiClient";

// --- THIS IS THE FIX ---
// 스토어에서 사용할 User 객체의 타입을 다른 파일에서도 쓸 수 있도록 export 합니다.
export interface User {
    id: string;
    name: string;
}

// 스토어의 상태와 액션 타입 정의
interface UserState {
    user: User | null;
    isInitialized: boolean;
    isAuthChecked: boolean; // 앱 시작 시 인증 확인이 끝났는지 여부
    checkAuth: () => Promise<void>; // 인증 상태를 확인하는 액션
    clearUser: () => Promise<void>; // 로그아웃 액션
}

const useUserStore = create<UserState>((set) => ({
    user: null,
    isInitialized: false,
    isAuthChecked: false,

    checkAuth: async () => {
        try {
            const response = await checkAuthStatus();
            set({ user: response.data, isAuthChecked: true, isInitialized: true });
        } catch (error) {
            set({ user: null, isAuthChecked: true, isInitialized: true });
        }
    },

    clearUser: async () => {
        try {
            await logout(); // 서버에 로그아웃 요청
        } catch (error) {
            console.error("Logout failed", error);
        } finally {
            set({ user: null }); // 성공/실패 여부와 관계없이 프론트엔드 상태는 로그아웃 처리

            const authServerLogout = authURL + "/logout";
            const finalDestination = encodeURIComponent(baseURL + "/login");
            window.location.href = `${authServerLogout}?continue=${finalDestination}`;
        }
    },
}));

export default useUserStore;

